import React, { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';

export default function Modal({ title, onClose, children, maxWidth = 'max-w-xl', className = '' }) {
  const tituloId = useId();
  const contenidoRef = useRef(null);
  const cuerpoRef = useRef(null);

  // Escape cierra el modal desde cualquier parte; el foco entra al primer
  // campo del formulario al abrir (o al contenedor si no hay ninguno) para
  // que el lector de pantalla anuncie el título y el teclado no se quede en
  // la pantalla de atrás.
  useEffect(() => {
    function alTeclear(e) {
      if (e.key === 'Escape') onClose?.();
    }
    window.addEventListener('keydown', alTeclear);
    const foco = cuerpoRef.current?.querySelector('input, select, textarea, button, [tabindex]');
    (foco || contenidoRef.current)?.focus({ preventScroll: true });
    return () => window.removeEventListener('keydown', alTeclear);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4 ${className}`}
      onMouseDown={onClose}
    >
      <div
        ref={contenidoRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={tituloId}
        tabIndex={-1}
        onMouseDown={(e) => e.stopPropagation()}
        className={`bg-white rounded-xl shadow-lg w-full ${maxWidth} max-h-[90vh] overflow-y-auto p-5 outline-none`}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 id={tituloId} className="text-lg font-semibold text-slate-800">{title}</h2>
          <button onClick={onClose} title="Cerrar" className="text-slate-400 hover:text-slate-600">
            <X size={20} />
            <span className="sr-only">Cerrar</span>
          </button>
        </div>
        <div ref={cuerpoRef}>{children}</div>
      </div>
    </div>
  );
}
